<template>
  <TabsIndicator
    v-bind="forwarded"
    :class="cn(tabsIndicatorVariants({ variant, animate }))"
  >
    <div :class="cn(innerVariants({ variant }), 'indicator')" />
  </TabsIndicator>
</template>

<script setup>
import { TabsIndicator, useForwardProps } from 'radix-vue';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils.js';

const props = defineProps({
  as: {
    type: String,
    required: false,
    default: 'div',
  },
  asChild: {
    type: Boolean,
    required: false,
    default: false,
  },
  variant: {
    type: String,
    required: false,
    default: 'underline',
  },
  animate: {
    type: Boolean,
    required: false,
  },
});

const forwarded = useForwardProps(props);

const tabsIndicatorVariants = cva(
  [
    'absolute translate-y-[--radix-tabs-indicator-position] rounded-full',
    'h-[--radix-tabs-indicator-size]',
  ],
  {
    variants: {
      variant: {
        underline: 'right-0 w-[2px]',
        highlight: 'w-full z-[-1]',
      },
      animate: {
        true: 'transition-[width,transform] duration-300',
      },
    },
    defaultVariants: {
      variant: 'underline',
      animate: false,
    },
  }
);

const innerVariants = cva(['bg-neutral-700/80 w-full h-full'], {
  variants: {
    variant: {
      highlight: 'rounded-md',
    },
  },
  defaultVariants: {
    variant: 'underline',
  },
});
</script>

<style scoped>
[variant='highlight'] .indicator {
  width: calc(100% - 2rem);
}
</style>
